<template>
  <div class="main-configurations">
    <nav>
      <ul>
        <the-tree v-for="branch in data" :branch="branch" :key="branch.label">
          <template v-slot:label="{ branch }">
            <router-link :to="{ name: branch.to }" v-if="!branch.children">
              <i v-if="branch.icon" :class="branch.icon"></i>
              <span>{{ branch.label }}</span>
            </router-link>
            <span v-else>
              <i v-if="branch.icon" :class="branch.icon"></i>
              <span >{{ branch.label }}</span>
            </span>
          </template>
        </the-tree>
      </ul>
    </nav>
    <div class="view">
      <TheBreadCrumbs :data="breadCrumbs" class="breadcrumbs" />
      <router-view :key="$route.params.name"/>
    </div>
  </div>
</template>

<script>
import TheTree from '@/components/common/TheTree'
import TheBreadCrumbs from '@/components/common/TheBreadCrumbs'
export default {
  props: {
    name: {
      required: false
    }
  },
  data () {
    return {
      data: [
        {
          label: 'Organizations',
          to: 'adminOrganizations',
          icon: 'fas fa-building',
        },
        {
          label: 'Servers',
          icon: 'fas fa-server',
          children: [
            {
              label: 'Media Servers',
              to: 'mediaservers'
            },
            {
              label: 'Mail Servers',
              to: 'ostickets'
            }
          ]
        },
        {
          label: 'Sign in art',
          to: 'sign-in-art',
          icon: 'fas fa-images',
        },
      ],
    }
  },
  components: {
    TheTree,
    TheBreadCrumbs
  },
  methods: {
    findItemByTo(menu, to) {
      for (const item of menu) {
          if (item.to === to) {
              return item;
          }
          if (item.children) {
              const found = this.findItemByTo(item.children, to);
              if (found) {
                  return found;
              }
          }
      }
      return null;
    }
  },
  computed: {
    breadCrumbs() {
      const defaultValues = [
        { label: 'Administration' },
      ]

      const selectMenu = this.findItemByTo(this.data, this.$route.name)
      if (selectMenu) {
        defaultValues.push({
          label: selectMenu.label
        })
      }

      return defaultValues
    }
  }
}
</script>

<style>
#app-main-content > .main-configurations {
  display: inline-flex!important;
  min-width: 100%;
  min-height: 100%;
  /* margin: var(--column); */
  /* width: 100%; */
}

/* #app-main-content > .main-configurations nav,
#app-main-content > .main-configurations nav a,
#app-main-content > .main-configurations nav span {
  color: var(--light-menu-links-color)!important;
} */

#app-main-content > .main-configurations nav a {
  text-decoration: none;
  display: block;
  width:  100%;
}

#app-main-content > .main-configurations nav a {
  color: var(--light-menu-links-color);
  padding: 8px;
}

#app-main-content > .main-configurations nav .child a {
  border-left: 2px solid transparent;
}

#app-main-content > .main-configurations nav button {
  padding: 8px;
  padding-left: 0px;
  color: var(--light-menu-links-color);
}

#app-main-content > .main-configurations nav .has-not-child a{
  padding-left: 0;
}

#app-main-content > .main-configurations nav  a:hover {
  color: var(--hiperpbx-dark-green);
}

#app-main-content > .main-configurations nav .child:hover {
  border-left: 1px solid var(--hiperpbx-dark-green);
}

#app-main-content > .main-configurations nav .child a:hover{
  color: var(--hiperpbx-dark-green);
  border-left: 2px solid var(--hiperpbx-dark-green);
}

#app-main-content .main-configurations nav .router-link-active {
  color: var(--hiperpbx-dark-green);
}

</style>

<style scoped>
.main-configurations {
  padding: 0px;
  background-color: white;
  /* min-width: 100%;
  min-height: 100%; */
  /* overflow-y:hidden; */
}

.main-configurations > nav {
  width: 200px;
  font-size: 14px;
  border-right: 1px solid #dcdfe6;
  padding: var(--column);
}

.main-configurations > nav i {
  margin-right: 8px;
}

.view {
  flex: 1
}

.breadcrumbs {
  margin: var(--column);
  margin-bottom: 0;
  font-size: 14px;
}
</style>